import enet_event_incident from '../../config/message_schemas/triggers/enet_event_incident.json';
import enet_event_match_day from '../../config/message_schemas/triggers/enet_event_match_day.json';
import enet_event_status from '../../config/message_schemas/triggers/enet_event_status.json';
import event_finished from '../../config/message_schemas/triggers/event_finished.json';
import event_halftime from '../../config/message_schemas/triggers/event_halftime.json';
import event_test from '../../config/message_schemas/triggers/event_test.json';
import event_starts from '../../config/message_schemas/triggers/event_starts.json';
import schedule from '../../config/message_schemas/triggers/schedule.json';
import time from '../../config/message_schemas/triggers/time.json';
import tourn_match_day from '../../config/message_schemas/triggers/tourn_match_day.json';
import tourn_round_starts from '../../config/message_schemas/triggers/tourn_round_starts.json';
import tourn_round_ends from '../../config/message_schemas/triggers/tourn_round_ends.json';
import transfer from '../../config/message_schemas/triggers/transfer.json';

export const triggerTypes = require('../../config/triggerTypes.json');
export const triggerTypesMap = triggerTypes.reduce((acc, cur) => {
    acc[cur.trigger] = cur;
    return acc;
}, {});

export const TRIGGER_SCHEMAS = {
    enet_event_incident,
    enet_event_status,
    enet_event_match_day,
    event_halftime,
    event_finished,
    event_test,
    event_starts,
    schedule,
    time,
    transfer,
    tourn_match_day,
    tourn_round_starts,
    tourn_round_ends,
};

export const TRIGGER_PAYLOAD = Object.keys(TRIGGER_SCHEMAS).reduce((acc, schemaKey) => {
    const props = TRIGGER_SCHEMAS[schemaKey].properties || {};
    acc[schemaKey] = Object.keys(props).reduce((accProps, prop) => {
        if (props[prop].required) {
            accProps.push(prop);
        }
        return accProps;
    }, []);
    return acc;
}, {});

/**
 * @param {String} triggerType
 * @returns {Object}
 */
export const getTriggerPayload = triggerType => {
    return (TRIGGER_PAYLOAD[triggerType] || []).reduce((acc, cur) => {
        acc[cur] = cur;
        return acc;
    }, {});
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/triggerConstants.js
 **/